import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "warning-white-orange",
  "use": "warning-white-orange-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"warning-white-orange\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <circle fill=\"#EEFCFF\" cx=\"9\" cy=\"9\" r=\"7.5\" />\n        <path d=\"M9 5.25a.75.75 0 0 1 .75.75v3.748a.704.704 0 0 1-.75.702.803.803 0 0 1-.75-.8V6A.75.75 0 0 1 9 5.25z\" fill=\"#ff9500\" />\n        <circle fill=\"#ff9500\" cx=\"9\" cy=\"12\" r=\"1\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol